<template>
  <div class="font-semibold text-sm text-gray-700 leading-tight tracking-normal">
    <el-breadcrumb :separator-icon="ArrowRight">
      <el-breadcrumb-item
        v-for="(item, index) in breadCrumbsData"
        :key="index"
        v-bind="index === breadCrumbsData.length - 1 ? {} : { to: item.to }"
        :class="[
          index === 0
            ? 'flex items-center text-gray-600 pt-2 hover:text-gray-800'
            : 'mt-3 text-gray-600 hover:text-gray-800',
        ]"
      >
        <template v-if="index === 0">
          <el-icon class="text-xl mr-1">
            <HomeFilled />
          </el-icon>
        </template>
        <span v-if="index !== 0" :class="{ 'font-bold': index === 2 }">{{ item.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { ArrowRight, HomeFilled } from '@element-plus/icons-vue'

export default {
  name: 'Breadcrumb',
  components: {
    HomeFilled, // Register HomeFilled icon here
  },
  props: {
    breadCrumbsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      ArrowRight,
    }
  },
}
</script>

<style>
.is-link {
  font-weight: 400 !important;
  color: #606266 !important;
}
</style>
